import React from 'react';
import { FormattedNumber } from 'react-intl';


const SAVINGS_MONTHLY_BALANCES = [
    1_000,
    5_000,
    10_000,
    50_000,
    100_000,
];

const SAVINGS_MONTHLY_BALANCES_OPTIONS = Object.values(SAVINGS_MONTHLY_BALANCES).map(value => ({
    value: value,
    label: (
        <FormattedNumber
            value={value}
            format="CAD0"
            minimumFractionDigits={0}
            maximumFractionDigits={0}
        />
    ),
}));


export { SAVINGS_MONTHLY_BALANCES };
export default SAVINGS_MONTHLY_BALANCES_OPTIONS;
